module.exports = __webpack_public_path__ + "static/media/app_icon.7d14f7d2.svg";